import { useCallback } from 'react';
import backendService from '../services/backendService';
import { useLearnActionClick } from '../utils/env';

export default function useFetchClickAction() {
  const fetchClickAction = useCallback(async (params) => {
    if (!useLearnActionClick) return;
    try {
      await backendService.experience.v4.clickAction(params);
    } catch (error) {
      console.error('fetchClickAction error:', error);
    }
  }, []);

  return {
    fetchClickAction,
  };
}
